(() => {
  if (window.BTCodBenefitInitialized) return;
  window.BTCodBenefitInitialized = true;

  const selectors = 'bt-cod-benefit';
  const compactContexts = new Set(['cart-drawer', 'cart', 'home']);
  let timer;

  const render = (subtotal) => {
    document.querySelectorAll(selectors).forEach((element) => {
      const limit = Number(element.dataset.limit || 100000000);
      const overLimit = subtotal > limit;
      const context = [...element.classList].find((name) => name.startsWith('bt-cod--') && name !== 'bt-cod--compact')?.replace('bt-cod--', '');
      const status = element.querySelector('.bt-cod__status');
      element.dataset.cartSubtotal = String(subtotal);
      element.dataset.overLimit = String(overLimit);
      if (!status) return;
      const message = overLimit
        ? 'Pago contra entrega disponible para pedidos de hasta $1.000.000.'
        : compactContexts.has(context)
          ? 'Hasta $1.000.000 · sujeto a cobertura.'
          : 'Hasta $1.000.000 · Sujeto a cobertura y condiciones del transportador.';
      if (status.textContent.trim() !== message) status.textContent = message;
    });
  };

  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })
        .then((response) => response.ok ? response.json() : Promise.reject(new Error('cart')))
        .then((cart) => render(Number(cart.total_price || 0)))
        .catch(() => {
          const first = document.querySelector(selectors);
          if (first) render(Number(first.dataset.cartSubtotal || 0));
        });
    }, 180);
  };

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length || mutation.target.closest?.('.js-cart-total'))) refresh();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener('click', (event) => {
    if (event.target.closest('[name="add"], .js-cart-drawer-btn, .js-cart-delete-btn, .js-quantity-btn')) refresh();
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[name="updates[]"], .js-quantity-input')) refresh();
  });
  refresh();
})();
